import { render } from "./Wxapp.vue?vue&type=template&id=3a9b94cc&scoped=true"
import script from "./Wxapp.vue?vue&type=script&lang=js"
export * from "./Wxapp.vue?vue&type=script&lang=js"

import "./Wxapp.vue?vue&type=style&index=0&id=3a9b94cc&scoped=true&lang=less"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9b94cc"]])

export default __exports__